import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';

// router setup
import router from './routes/router';
import i18n from './i18n';
import './registerServiceWorker'

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);

// Initialize Firebase
var firebaseConfig = {
  apiKey: "AIzaSyDztL60MsoHPD88RIJkTlblFHhoH-SjMyk",
  authDomain: "jamah-sinaw-2019.firebaseapp.com",
  databaseURL: "https://jamah-sinaw-2019.firebaseio.com",
  projectId: "jamah-sinaw-2019",
  storageBucket: "jamah-sinaw-2019.appspot.com",
  messagingSenderId: "962358344643",
  appId: "1:962358344643:web:cc806bef1d36bef6"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// var database = firebase.database().ref().child('users');
// database.on('value', snap => console.log(snap.val()));

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n
});
